import { init } from '@sentry/browser';

Config.SENTRY_ENABLED && init({
  dsn: 'https://f09c9551c61c43708cd1d5b8d2366ed7@sentry.io/1335387',
  environment: APP_ENV
});
